import type { OnClickCallback } from '@atlaskit/editor-common/card/cardOptions';
import { isSSR } from '@atlaskit/editor-common/is-ssr';
import type { CardProvider } from '@atlaskit/editor-common/provider-factory/card-provider';
import type { LinkPickerOptions } from '@atlaskit/editor-common/types/hyperlink';
import type { CardPluginOptions } from '@atlaskit/editor-plugin-card/types';

/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */
const SMART_LINKS_BEFORE_MACROS =
	'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');

interface Props {
	options: {
		__livePage: boolean | undefined;
		CompetitorPrompt?: React.ComponentType<{ linkType?: string; sourceUrl: string }>;
		linkPicker: LinkPickerOptions | undefined;
		onClickCallback: OnClickCallback | undefined;
	};
	providers: {
		cardProvider: Promise<CardProvider> | undefined;
	};
}

declare global {
	interface Window {
		__SSR_RENDERED__?: boolean;
	}
}

/**
 *
 * @param root0
 * @param root0.options
 * @param root0.providers
 * @example
 */
export function cardPluginOptions({ options, providers }: Props): CardPluginOptions {
	return {
		allowDatasource: false,
		provider: providers.cardProvider,
		resolveBeforeMacros: SMART_LINKS_BEFORE_MACROS,
		allowBlockCards: true,
		allowEmbeds: true,
		onClickCallback: options.onClickCallback,
		fullWidthMode: false,
		linkPicker: options.linkPicker,
		lpLinkPicker: true,
		editorAppearance: 'full-page',
		// @ts-ignore Temporary solution to check for Live Page editor.
		__livePage: options.__livePage,
		isPageSSRed: Boolean(isSSR() || window.__SSR_RENDERED__),
		CompetitorPrompt: options.CompetitorPrompt,
	};
}
